import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const PACKINGTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PackingType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.PackingType.Code')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
];

export const PACKINGTYPE_CONFIG = {
  entityName: 'PackingType',
  localizationKey: 'Planning::Entity.PackingType',
  fields: PACKINGTYPE_FIELDS,
  permission: 'Planning.PackingTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
};
